import React from 'react';
import PropTypes from 'prop-types';
import {Link} from 'react-router-dom';
import {makeStyles} from "@material-ui/styles";
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles(theme => ({
    link: {
        color: '#b24d43',
        textDecoration: 'none',
    },
    paper: {
        backgroundColor: 'rgb(238, 240, 251)',
        paddingBottom: '24px',
        paddingTop: '24px',
    }
}));

const DripCampaignMetricBox = (props) => {
    const {dripCampaignId, label, type, value, ...rest} = props;
    const classes = useStyles();

    const getLinkPath = () => {
        // Nested, not 'status.value': the filter form reads it by path and ldjsonServer
        // flattens it again for the API. A flat key filters the list but leaves the
        // status dropdown empty.
        const filter = { dripCampaign: dripCampaignId };
        if (type && type !== 'total') {
            filter.status = { value: type };
        }
        return `/drip-enrollments?filter=${JSON.stringify(filter)}`;
    };

    return (
        <Paper square elevation={2} className={classes.paper} {...rest}>
            <Typography align={'center'} variant={'title'} color={'primary'}>
                {value === 0 && `0`}
                {value > 0 && <Link to={getLinkPath()} className={classes.link}>{value}</Link>}
            </Typography>
            <Typography align={'center'} variant={'caption'}>{label}</Typography>
        </Paper>
    );
};

DripCampaignMetricBox.propTypes = {
    dripCampaignId: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    type: PropTypes.oneOf(['queued', 'sent', 'failed', 'cancelled', 'skipped', 'rate', 'total']),
    value: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string
    ]).isRequired,
};

export default DripCampaignMetricBox;